export const ACTIVE_MATCH_STATUSES = [
  'Not engaged',
  'Negotiating',
  'Reviewing T&Cs',
  'Contracted',
];

export type CategorisableCustomer = {
  match: {
    userBusinessId?: string;
    matchStatus?: string;
  };
};

export const isMatchStillLive = (customer: CategorisableCustomer) =>
  ACTIVE_MATCH_STATUSES.includes(customer.match?.matchStatus ?? '');

export function splitCustomersByType<T extends CategorisableCustomer>(
  customers: T[]
): { current: T[]; former: T[] } {
  const businessesWithALiveMatch = new Set(
    customers
      .filter(isMatchStillLive)
      .map((customer) => customer.match?.userBusinessId)
      .filter(Boolean)
  );

  const isEndedMatchOfALiveCustomer = (customer: T) => {
    const businessId = customer.match?.userBusinessId;
    return !!businessId && businessesWithALiveMatch.has(businessId);
  };

  return {
    current: customers.filter(isMatchStillLive),
    former: customers.filter(
      (customer) =>
        !isMatchStillLive(customer) && !isEndedMatchOfALiveCustomer(customer)
    ),
  };
}
